module.exports = __webpack_public_path__ + "media/images/bnr-delivery-sm-c16a7841b660fedc93dc00c2a1b0f468.png";